import {
    DEPART_DIRECTION,
    RETURN_DIRECTION,
} from '../../../constants';
import { serializeFilterParams } from '../../../utils';
import { selectFilterId } from '../selectors';
import * as types from '../types';
import {
    resetAllowNearby,
} from './allowNearby';
import {
    resetCarriers,
} from './carriers';
import {
    resetDirectOnly,
} from './directOnly';
import {
    resetFeatures,
} from './features';
import {
    resetArriveStations,
    resetDepartStations,
} from './stations';
import {
    resetArrivalTiming,
    resetDepartureTiming,
} from './timing';
import {
    resetTravelModes,
} from './travelModes';

function _setNewFilterId(filterId) {
    return {
        meta: {
            filterId,
        },
        type: types.SET_NEW_FILTER_ID,
    };
}

function setNewFilterIds(searchParams) {
    return (dispatch, getState) => {
        const departFilterId = serializeFilterParams({
            ...searchParams,
            direction: DEPART_DIRECTION,
        });
        dispatch(_setNewFilterId(departFilterId));

        if (!searchParams.returnDate) {
            return;
        }

        const returnFilterID = serializeFilterParams({
            ...searchParams,
            direction: RETURN_DIRECTION,
        });
        dispatch(_setNewFilterId(returnFilterID));
    };
}

function setBulk(filterSet, filterId) {
    return {
        type: types.SET_BULK,
        meta: filterId,
        payload: filterSet,
    };
}

function resetAllFilters(filterId) {
    return (dispatch, getState) => {
        filterId = filterId || selectFilterId(getState());

        dispatch(resetAllowNearby(filterId));
        dispatch(resetDirectOnly(filterId));
        dispatch(resetCarriers(filterId));
        dispatch(resetFeatures(filterId));
        dispatch(resetArrivalTiming(filterId));
        dispatch(resetDepartureTiming(filterId));
        dispatch(resetTravelModes(filterId));
        dispatch(resetArriveStations(filterId));
        dispatch(resetDepartStations(filterId));
    };
}

export {
    resetAllFilters,
    setBulk,
    setNewFilterIds,
};
